import { Tooltip as MantineTooltip } from '@mantine/core';

export const Tooltip = MantineTooltip.extend({
	defaultProps: {
		withArrow: true,
		arrowSize: 16,
		offset: 5,
		arrowRadius: 5,
		arrowOffset: 35,
		arrowPosition: 'side',
		withinPortal: false,
		transitionProps: {
			transition: 'fade',
			duration: 150,
		},
	},
});
